import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import DynamicTariff from './dynamic-tariff';
import DynamicTariffDetail from './dynamic-tariff-detail';
import DynamicTariffUpdate from './dynamic-tariff-update';
import DynamicTariffDeleteDialog from './dynamic-tariff-delete-dialog';

const DynamicTariffRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<DynamicTariff />} />
    <Route path="new" element={<DynamicTariffUpdate />} />
    <Route path=":id">
      <Route index element={<DynamicTariffDetail />} />
      <Route path="edit" element={<DynamicTariffUpdate />} />
      <Route path="delete" element={<DynamicTariffDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default DynamicTariffRoutes;
